//i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./lang/ar/index";
import br from "./lang/br/index";
import cn from "./lang/cn/index";
import en from "./lang/en/index";
import id from "./lang/id/index";
import inn from "./lang/in/index";
import kr from "./lang/kr/index";
import jp from "./lang/jp/index";
import tw from "./lang/tw/index";
import it from "./lang/it/index";
import fr from "./lang/fr/index";
import ru from "./lang/ru/index";
import es from "./lang/es/index";
import de from "./lang/de/index";
import tr from "./lang/tr/index";
import nl from "./lang/nl/index";

import Utils from "../utils/utils";
const resources = { ar, cn, en, id, inn, kr, br, jp, tw, it, fr, ru, es, de, tr, nl };

// //测试地址
// const rootElement = document.getElementById("hitpaw-online-root");
// let urlParams = new URLSearchParams(window.location.search);
// if (urlParams.has("lang")) {
//   rootElement.setAttribute("lang", urlParams.get("lang"));
// }
let lang = Utils.getLanguage();
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: lang === "in" ? "inn" : lang,
    // lng: "kr",
    keySeparator: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
